import Navbar from "../../components/player/Navbar.tsx";
import PlayerMail from "../../components/player/messaging/PlayerMail.tsx";
import "../../styles/Navigation.css";
import { usePlayerChrome } from "../../hooks/usePlayerChrome.ts";

/**
 * Represents the messaging layout for the player.
 */
const LayoutMessaging = () => {
    usePlayerChrome();

    return (
        <div className="player-layout">
            <Navbar />
            <div className="container-fluid grow player-main-surface" style={{ paddingTop: 110, paddingLeft: 0, paddingRight: 0 }}>
                <PlayerMail />
            </div>
        </div>
    );
}
export default LayoutMessaging;
